module.exports = __webpack_public_path__ + "img/visa.f507d440.svg";